const LOGO_URL = "/assets/who-logo.png";

export default function Logo({ variant = "dark" }) {
  const isLight = variant === "light";

  if (isLight) {
    // Light (footer / dark background) wordmark — the provided logo art is navy-on-white,
    // so we render a clean white wordmark that mirrors its structure.
    return (
      <div className="flex items-center gap-3" data-testid="who-logo-light">
        <div className="leading-tight">
          <div className="font-display text-3xl font-black tracking-tight text-white">
            WH<span className="text-gold">O</span>
          </div>
          <div className="mt-1 flex items-center gap-2">
            <span className="h-px w-4 bg-white/40" />
            <span className="text-[11px] tracking-[0.28em] font-bold uppercase text-gold">
              Warm Hand Off
            </span>
            <span className="h-px w-4 bg-white/40" />
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center" data-testid="who-logo">
      <img
        src={LOGO_URL}
        alt="WHO — Warm Hand Off. Coordination infrastructure for veterans and the organizations that serve them."
        className="h-28 md:h-32 lg:h-36 xl:h-40 w-auto object-contain"
        loading="eager"
        decoding="async"
      />
    </div>
  );
}
